const css = `@charset "UTF-8";
.routines-header-options {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}
@media (max-width: 576px) {
  .routines-header-options {
    gap: 8px;
    /* Ajustar botones para dispositivos móviles */
  }
  .routines-header-options > button,
  .routines-header-options > div {
    margin-bottom: 8px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1JvdXRpbmVzIiwic291cmNlcyI6WyJSb3V0aW5lcy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUVBO0VBTkY7SUFPSTtBQUVBOztFQUNBO0FBQUE7SUFFRSIsInNvdXJjZXNDb250ZW50IjpbIi5yb3V0aW5lcy1oZWFkZXItb3B0aW9ucyB7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGdhcDogMTZweDtcbiAgZmxleC13cmFwOiB3cmFwO1xuXG4gIEBtZWRpYSAobWF4LXdpZHRoOiA1NzZweCkge1xuICAgIGdhcDogOHB4O1xuXG4gICAgLyogQWp1c3RhciBib3RvbmVzIHBhcmEgZGlzcG9zaXRpdm9zIG3Ds3ZpbGVzICovXG4gICAgPiBidXR0b24sXG4gICAgPiBkaXYge1xuICAgICAgbWFyZ2luLWJvdHRvbTogOHB4O1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
